import { createReducer, updateState } from 'redux/handlers'
import types from './types'

const initialState = {
  alternatives: [],
  alternativesModalActionRef: [],
  alternativesActionDetail: [],
  alternativesActionsErrors: [],
  modalError: null,
  loading: false,
  error: null
}

const updateAlternatives = (state, action) => updateState(state, { alternatives: action.payload })

const updateAlternativesModalActionRef = (state, action) => updateState(state, { alternativesModalActionRef: action.payload })

const updateAlternativesActionDetail = (state, action) => updateState(state, { alternativesActionDetail: action.payload })

const updateAlternativesActionsErrors = (state, action) => updateState(state, { alternativesActionsErrors: action.payload })

const updateModalError = (state, action) => updateState(state, { modalError: action.payload })

const updateLoading = (state, action) => updateState(state, { loading: action.payload })

const updateError = (state, action) => updateState(state, { error: action.payload })

export default createReducer(initialState, {
  [types.SMARTCHAT_ALTERNATIVES_UPDATE]:                    updateAlternatives,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF]:   updateAlternativesModalActionRef,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL]:      updateAlternativesActionDetail,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS]:     updateAlternativesActionsErrors,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ERROR]:        updateModalError,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_LOADING]:            updateLoading,
  [types.SMARTCHAT_ALTERNATIVES_UPDATE_ERROR]:              updateError
})
